export enum TicketTypes {
    TICKET = 'ticket',
    REOPEN = 'reopen'
};